/* eslint-disable no-nested-ternary */
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Modal } from '../..';
import { Store, useAuth } from '../../../context/authContext';
import { paths } from '../../../routes';

type ModalProps = {
  notice: string;
  title: string;
  store: Store;
  onCloseModal: () => void;
};

function RestrictionPrompt({ notice, title, store, onCloseModal }: ModalProps) {
  const [, dispatch] = useAuth();
  const [status, setStatus] = React.useState<
    'IDLE' | 'LOADING' | 'RESOLVED' | 'REJECTED'
  >('IDLE');

  const navigate = useNavigate();

  return (
    <Modal show className="tablet:align-middle tablet:w-[500px]">
      <div className="rounded-md bg-white">
        <div className="flex flex-col items-center px-5 py-5">
          <h3
            className="text-pos-black text-2xl tablet:text-3xl font-semibold mb-2
              inline-flex text-center tablet:leading-[2.5rem]"
          >
            {title}
          </h3>

          <div className="text-pos-black text-center text-base mb-2 font-normal space-y-4">
            <p>{notice}</p>
          </div>
        </div>

        <div className="w-full text-right flex flex-row justify-center tablet:justify-end ml-auto space-x-4 bg-pos-yellow px-5 py-7 rounded-b-md">
          <Button
            label="Get help"
            onClick={() =>
              navigate(`${paths.LANDING_SUPPORT_URL_PATH}?store=${store.name}`)
            }
            type="button"
            className="!bg-transparent border-2 border-pos-black min-w-[100px]  h-[40px]
            items-center justify-center !text-pos-black text-xbase
            shadow-[0_1px_0_rgba(27,31,36,0.1),inset_0_1px_0_rgba(255,255,255,0.03)] shrink-0 font-medium"
          />

          <Button
            label="Okay"
            onClick={onCloseModal}
            type="button"
            disabled={status === 'LOADING'}
            loading={status === 'LOADING'}
            className="!bg-pos-black border border-[rgba(27,31,36,0.15)] min-w-[150px]  h-[40px]
            items-center justify-center !text-pos-yellow text-xbase
            shadow-[0_1px_0_rgba(27,31,36,0.1),inset_0_1px_0_rgba(255,255,255,0.03)] shrink-0 font-medium"
          />
        </div>
      </div>
    </Modal>
  );
}

export default RestrictionPrompt;
